define(['underscore'], (_) => {

    return ['$q', 'JsonRPCService', ($q, JsonRPCService) => {
        return {
            knownValidStreets: [], //array of addresses(city,postcode,street)
            knownInvalidStreets: [], //array of addresses(city,postcode,street)
            inFly: [], //array of addresses(city,postcode,street) + promises

            findCityByPostalCode: function (callGroups, postalCode) {
                var deferred = $q.defer();
                JsonRPCService.send('addresslookup', 'addresslookup', 'findCityByPostalCode', [{postalCode: postalCode}], callGroups, true).then(
                    function (response) {
                        return deferred.resolve(response);
                    }, function (error, status, headers) {
                        return deferred.reject([error, status, headers]);
                    });
                return deferred.promise;
            },

            completeStreetName: function (callGroups, street, plz, ort) {

                var knownValidStreets = this.knownValidStreets;
                var deferred = $q.defer();
                
               JsonRPCService.send('addresslookup', 'addresslookup', 'completeStreetName', [street, plz, ort], callGroups, true).then(
                     function (response) {

                         // For each street returned by the backend, if is not already known, we are going to store it
                         _.each(response, function(element){
                             var alreadyKnown = _.findWhere(knownValidStreets, {city: ort, postalCode: plz, street: element});
                             if(!alreadyKnown){
                                 knownValidStreets.push({city: ort, postalCode: plz, street: element});
                             }
                         });

                        return deferred.resolve(response);
                    }, function (error, status, headers) {
                        return deferred.reject([error, status, headers]);
                    });
                return deferred.promise;
            },

            /**
             * @param callGroups
             * @param postalCode
             * @param city
             * @param street
             * @return true, false or promise
             */
            validateStreet: function (callGroups, postalCode, city, street) {

                // Checking that we're not sending and empty postalCode or city
                if (_.isEmpty(postalCode) || _.isEmpty(city) || _.isEmpty(street)) {
                    return false;
                }

                // Invalidate any street if the street validation is still in fly
                var inFlyObj = _.findWhere(this.inFly, {city: city, postalCode: postalCode, street: street});
                if (inFlyObj) {
                    return inFlyObj.promise;
                }

                // Checking if we already know that the street is valid
                if(_.findWhere(this.knownValidStreets, {city: city, postalCode: postalCode, street: street})){
                    return true;
                }

                // Checking if we already know that the street is invalid
                if(_.findWhere(this.knownInvalidStreets, {city: city, postalCode: postalCode, street: street})){
                    return false;
                }

                // Preparing a deferred promise for calling backend
                var deferred = $q.defer();
                
                // Inside the JsonRPCService.send.then context we don't have access to any AddressLookupService property, 
                // therefore we need a local variable just pointing to the global variables to be used inside that context.
                var _knownValidStreets = this.knownValidStreets;
                var _knownInvalidStreets = this.knownInvalidStreets;
                var _inFly = this.inFly;

                // Checking the backend for an street
                JsonRPCService.send('addresslookup', 'addresslookup', 'validateStreet', [postalCode, city, street], callGroups, true).then(
                    function (response) {

                        // Removing the street from the inFly array
                        var obj = _.findWhere(_inFly, {city: city, postalCode: postalCode, street: street});
                        var index = _inFly.indexOf(obj);
                        if (index > -1) {
                             _inFly.splice(index, 1);
                        }

                        var lastStateValue = (response === true);

                        // After knowing if the steet is valid or not, store that street in the knownValid/Invalid array
                        if(lastStateValue){
                            if(!_.findWhere(_knownValidStreets, {city: city, postalCode: postalCode, street: street})){
                                _knownValidStreets.push({city: city, postalCode: postalCode, street: street});
                            }
                        }else{
                            if(!_.findWhere(_knownInvalidStreets, {city: city, postalCode: postalCode, street: street})){
                                _knownInvalidStreets.push({city: city, postalCode: postalCode, street: street});
                            }
                        }

                        // Resolving the promise with the result
                        return deferred.resolve(lastStateValue);
                    }, function (error, status, headers) {
                        return deferred.reject([error, status, headers]);
                    }
                );

                // Pushing the street to the array of elements on fly
                this.inFly.push({city: city, postalCode: postalCode, street: street, promise: deferred.promise});


                return deferred.promise;
            }
        };
    }];
});


// WEBPACK FOOTER //
// ../common/js/src/edge/policyjob/services/AddressLookupService.js